import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {EvsProductService} from '../../../../../common/services/EvsProduct.service';
import {ConfirmationService} from 'primeng/primeng';
import {ImageService} from '../../../../imageService';
import {AuthBusinessService} from '../../../../../common/services/AuthBusiness.service';
import { debounce } from 'lodash';

declare var $: any;

@Component({
  selector: 'app-select2Api',
  templateUrl: './select2Api.component.html',
  styles: [``],
  styleUrls: ['./select2Api.component.css'],
  providers: [EvsProductService, ImageService, AuthBusinessService],
})
export class Select2ApiComponent implements OnInit {
  @Output() loadDataSearchParent = new EventEmitter();
  @Output() searchParent = new EventEmitter();
  listData: any;
  valueSelect;
  valueText;
  searchData;
  width;
  constructor(
  ) {
    this.search = debounce(this.search, 500)

  }

  ngOnInit() {

  }

  sendData(data) {
    this.listData = data.listData;
    this.valueText = data.placeholder;
    this.width = data.width;
  }

  saveValue(e) {
    this.valueSelect = e.id;
    this.valueText = e.value;
    this.loadDataSearchParent.emit(this.valueSelect);
  }

  search() {
    this.searchParent.emit(this.searchData);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/select2Api/select2Api.component.ts